import 'twin.macro';
import React from 'react';
import { ClassroomColumn } from './ClassroomColumn';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { getClassroomsWithEvents } from '@teetsh/app/src/containers/CahierJournal/DayColumn/getClassroomsWithEvents';
import { CJEvent } from '@teetsh/app/src/types/event';
import { ClassroomsOrg } from '@teetsh/app/src/types/school';

interface Props {
  allClassrooms: Classroom[];
  classrooms: Classroom[];
  events: CJEvent[];
  classroomsOrg: ClassroomsOrg;
  day: Date;
}

export function DayPreview(props: Props) {
  const { classrooms, events, classroomsOrg, day } = props;

  const classroomsWithEvents = getClassroomsWithEvents(
    props.allClassrooms,
    events || [],
    'all',
    day,
    classroomsOrg,
  );
  return (
    <div
      tw="flex min-h-0 min-w-0 max-h-full space-x-2"
      aria-label="day-classrooms-wrapper"
    >
      {classroomsWithEvents.map(classroom => (
        <ClassroomColumn
          expanded={true}
          classroom={classroom}
          key={classroom.id}
          classroomsOrg={classroomsOrg}
          classrooms={classrooms}
          collapsed={false}
        />
      ))}
    </div>
  );
}
